import { useEffect } from "react";
import Lenis from "lenis";

// Lenis takes over wheel/touch scrolling for the whole document, so a modal
// can't just rely on CSS overflow to stop the page behind it from scrolling
// — Lenis has to be told to pause. Exposed as a module-level singleton so
// any component (e.g. EnquiryDialog) can pause/resume it while open.
let lenisInstance = null;

export function pauseSmoothScroll() {
  lenisInstance?.stop();
}

export function resumeSmoothScroll() {
  lenisInstance?.start();
}

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
  return null;
}
